module.exports = __webpack_public_path__ + "assets/img/fe02e0ec90b7554e6cbd108e9b0b3a8c.svg";